import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellLogAction: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellLogAction' };

import { computed } from 'vue';
import type { OutputLogEvent } from '@models';

/**
 * `TableCellLogAction` component properties.
 */
export interface Props {
    item: OutputLogEvent;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: OutputLogEvent;
};



const action = computed(() => props.item.action);
const url = computed(() => props.item.url);
const method = computed(() => props.item.method);

const tooltip = computed(() => {
    return `${method.value} ${url.value}`;
});

return { __sfc: true,props, action, url, method, tooltip }
}

})